import {
  intervalToDuration,
  formatDuration,
  parseISO,
  isValid,
  isBefore,
} from 'date-fns'
import { pt, enUS, es } from 'date-fns/locale'

import { useTranslation } from '@flecto/translations'
import { type CoreLocale } from '@flecto/types'

export function useTimeUntil(start_at: string) {
  const {
    i18n: { language },
  } = useTranslation()

  const now = new Date()
  const parsedFutureDate = parseISO(start_at)

  if (!isValid(parsedFutureDate)) {
    return
  }

  if (isBefore(parsedFutureDate, now)) {
    return null
  }

  const duration = intervalToDuration({ start: now, end: parsedFutureDate })

  const localeMap = {
    pt: pt,
    en: enUS,
    es: es,
  }

  const selectedLocale = localeMap[language as CoreLocale]

  let format: (
    | 'years'
    | 'months'
    | 'days'
    | 'hours'
    | 'minutes'
    | 'seconds'
  )[] = []

  if (duration.years && duration.years > 0) {
    format = ['years', 'months']
  } else if (duration.months && duration.months > 0) {
    format = ['months']
  } else if (duration.days && duration.days > 0) {
    format = ['days']
  } else if (duration.hours && duration.hours > 0) {
    format = ['hours']
  } else if (duration.minutes && duration.minutes > 0) {
    format = ['minutes']
  } else {
    format = ['seconds']
  }

  const formatted = formatDuration(duration, {
    locale: selectedLocale,
    format,
    zero: false,
  })

  return formatted
}
